var _style, _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCircleFlare1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.62,6.86V3.98c3.85,2.32,7.08,5.55,9.4,9.4h-2.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.38,6.86V3.98c-3.85,2.32-7.08,5.55-9.4,9.4h2.86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.62,53.14v2.87c3.85-2.32,7.08-5.55,9.4-9.4h-2.86"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 28.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.65,30c0,14.16-11.49,25.65-25.65,25.65S4.35,44.16,4.35,30S15.84,4.35,30,4.35S55.65,15.84,55.65,30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.38,53.14v2.87c-3.85-2.32-7.08-5.55-9.4-9.4h2.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircleFlare1);
export default __webpack_public_path__ + "static/media/double_circle_flare_1.950152056d202073e18b05233da1ccbe.svg";
export { ForwardRef as ReactComponent };